const ITEMS = [
  "Ferrari",
  "Bentley",
  "Lamborghini",
  "Aston Martin",
  "Porsche",
  "McLaren",
  "Mercedes-AMG",
  "BMW M",
  "Sherwin-Williams OEM Color",
  "ADAS Laser Calibration",
  "I-CAR Gold Class",
  "Carrollton — DFW Metroplex",
];

export const Marquee = () => (
  <section
    data-testid="brand-marquee"
    aria-label="Marques and certifications serviced"
    tabIndex={0}
    className="marquee brand-marquee-mask relative border-y border-white/[0.07] bg-surface/60 py-6 overflow-hidden outline-none"
  >
    <div className="animate-marquee flex w-max items-center">
      {[0, 1].map((copy) => (
        <div key={copy} className={`marquee-copy flex items-center${copy === 1 ? " marquee-dup" : ""}`} aria-hidden={copy === 1}>
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="font-display text-lg sm:text-xl font-semibold tracking-[0.14em] uppercase text-slate-400/80 px-8 whitespace-nowrap">
                {item}
              </span>
              <svg width="10" height="10" viewBox="0 0 10 10" className="text-accent/70 shrink-0" aria-hidden="true">
                <path d="M5 0 L10 5 L5 10 L0 5 Z" fill="currentColor" />
              </svg>
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
